import { leftToStartFrame, TRACK_HEIGHT } from '../helper';
import { findElementById } from '../../../helpers/elementtree';
import { findElementByIdForSnap } from './snapping';

const getSameDepthItems = (selfId: any, elements: any[], renderAbleItems: any[]) => {
    return elements
        .map((element: any) => renderAbleItems.find((item: any) => item.element.id === element.id))
        .filter((item: any) => item && item.element.id !== selfId);
};

const getGroupRenderAbleItems = (selfId: any, groupId: any, elements: any[], renderAbleItems: any[]) => {
    const group: any = findElementById(elements, groupId);

    return getSameDepthItems(selfId, [...group.children, group], renderAbleItems);
};

const findClosestElement = (elementsToCompare: any[], top: number) => {
    return elementsToCompare.reduce((prev: any, curr: any) => {
        const prevTop = parseFloat(prev.style.top);
        const currTop = parseFloat(curr.style.top);
        const diffWithPrev = Math.abs(top - prevTop);
        const diffWithCurr = Math.abs(top - currTop);

        return diffWithPrev < diffWithCurr ? prev : curr;
    });
};

export const computeDropResults = (
    elements: any[],
    renderAbleItems: any[],
    duration: number,
    elementId: any,
    top: number,
    leftPercentage: number,
    groupId: any,
    isBetweenTracks: boolean,
    { elementId: snapElementId, fromRight, toLeft }: any,
) => {
    const itemsToCompare =
        groupId && elementId.toString() !== groupId.toString()
            ? getGroupRenderAbleItems(elementId, groupId, elements, renderAbleItems)
            : getSameDepthItems(elementId, elements, renderAbleItems);

    const trackIdx = (top / TRACK_HEIGHT) << 0;
    const trackTop = trackIdx * TRACK_HEIGHT + 3;
    const firstElementOnTrack: any =
        !itemsToCompare.length || itemsToCompare.find((item: any) => parseFloat(item.style.top) === trackTop);
    let targetRenderOrder = 0;

    if (itemsToCompare.length) {
        if (!firstElementOnTrack || isBetweenTracks) {
            const closestRenderAbleItem = findClosestElement(itemsToCompare, top);
            const isAbove = parseFloat(closestRenderAbleItem.style.top) < top;
            const { renderOrder } = closestRenderAbleItem.element;

            targetRenderOrder = renderOrder + (isAbove ? -0.5 : 0.5);
        } else {
            targetRenderOrder = firstElementOnTrack.element.renderOrder;
        }
    }

    let startFrame: any = '';

    if (snapElementId) {
        const snapElement: any = findElementByIdForSnap(elements, snapElementId, duration);
        startFrame = snapElement.startFrame;

        if (!toLeft) {
            startFrame += snapElement.duration;
        }

        if (fromRight) {
            startFrame -= (findElementById(elements, elementId) as any).duration;
        }
    } else {
        startFrame = leftToStartFrame(duration, leftPercentage);
    }

    return [targetRenderOrder, startFrame];
};
